"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Rewards = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 32 32" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.Path, { fill: "none", d: "M0 0h32v32H0z" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "M16 12.43v14.285M13.929 6.358a2.643 2.643 0 0 0-2.215-1.072 2.857 2.857 0 0 0-1.893 5C11.321 11.608 16 12.43 16 12.43c0-2.143-1.214-5.107-2.071-6.071zm4.142 0c.517-.7 1.345-1.1 2.215-1.072a2.857 2.857 0 0 1 1.893 5C20.679 11.608 16 12.43 16 12.43c0-2.143 1.214-5.107 2.071-6.071zm6.5 10.357v10H7.43v-10M6.5 12.429h19v4.286h-19v-4.286z", stroke: color }))));
};
Rewards.defaultProps = {
    width: 32,
    height: 32,
    color: '#111111FF',
};
exports.default = react_1.default.memo(Rewards);
